export enum ReservationStage {
    Confirmed = 'confirmed',
    // Pending = 'pending',
    Canceled = 'canceled',
    Internal_Unknown = 'unknown' //! This should never be displayed. It indicates a bad model.
};
